import { Check } from "lucide-react";

export const Stepper = ({ stages }) => {
  return (
    <div className="space-y-0" data-testid="onboarding-stepper">
      {stages.map((stage, i) => {
        const isLast = i === stages.length - 1;
        const done = stage.state === "complete";
        const active = stage.state === "in_progress";
        return (
          <div key={stage.key} className="flex gap-4" data-testid={`stage-${stage.key}`}>
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full border flex items-center justify-center shrink-0 transition-colors ${
                  done
                    ? "bg-emerald-500/15 border-emerald-500 text-emerald-400"
                    : active
                    ? "bg-amber-500/10 border-amber-500/70 text-amber-300"
                    : "bg-slate-900 border-slate-700 text-slate-600"
                }`}
              >
                {done ? (
                  <Check className="w-4 h-4" strokeWidth={2.5} />
                ) : (
                  <span className="font-mono-ui text-xs">{i + 1}</span>
                )}
              </div>
              {!isLast && (
                <div className={`w-px flex-1 min-h-[28px] my-1 ${done ? "bg-emerald-600/50" : "bg-slate-800"}`} />
              )}
            </div>
            <div className={`pb-6 ${isLast ? "pb-0" : ""}`}>
              <p className={`text-sm font-medium ${done || active ? "text-slate-100" : "text-slate-500"}`}>
                {stage.label}
              </p>
              <p className="font-mono-ui text-[10px] uppercase tracking-[0.2em] mt-0.5 text-slate-500">
                {stage.state === "complete" ? "Complete" : stage.state === "in_progress" ? "Action Required" : "Locked"}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
